export default __webpack_public_path__ + "static/media/visuals.93122fed.svg";